import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SignIn from '../components/SignIn/SignIn';
import { validationErrorTransformer } from '../store/api';
import { ValidatedField } from '../store/api.d';
import { selectAuthValidationErrors } from '../store/auth/selector';
import authSlice from '../store/auth/slice';
import { AuthState, LoginRequest } from '../store/auth/types';
import { AppState } from '../store/state';
import { AppDispatch } from '../store/store';
import { selectAuth } from '../store/selectors';

interface SingInPageProps {
  login: (data: LoginRequest) => void;
  clearValidationMessages: () => void;
  auth: AuthState;
  validationErrors: ValidatedField[];
  loading: boolean;
}

const SignInPage: React.FC<SingInPageProps> = ({ login, clearValidationMessages, auth, validationErrors, loading }) => {
  const history = useHistory();

  useEffect(() => {
    return () => clearValidationMessages();
  }, []);

  const forgot_password_handler = () => {
    history.push('/forgot-password');
  };

  const signup_handler = () => {
    history.push('/signup');
  };

  return (
    <SignIn
      sign_in_handler={login}
      forgot_password_handler={forgot_password_handler}
      signup_handler={signup_handler}
      validation_error={auth.validationError ? validationErrorTransformer(validationErrors) : undefined}
      clearValidationMessages={clearValidationMessages}
      loading={loading}
    />
  );
};

const mapStateToProps = (state: AppState) => ({
  auth: state.auth,
  validationErrors: selectAuthValidationErrors(state),
  loading: selectAuth(state).loadingRequest,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  login: (data: LoginRequest) => dispatch(authSlice.actions['LOGIN'](data)),
  clearValidationMessages: () => dispatch(authSlice.actions['CLEAR:VALIDATION']()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);
